export class Csp5090Class {
    UserNam: string;
}
